export const subscriptions = {
  SUBSCRIPTIONS: 'v2/analytics/subscriptions',
  SUBSCRIPTIONS_BY_STATUS: 'v2/analytics/subscriptions/{groupBy}',
  SUBSCRIPTIONS_COUNTRIES: 'v2/analytics/subscriptions/countries',
};
